import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { toast, Bounce } from 'react-toastify';
import { Button } from 'components/Button';
import { getWarehousesApi, deleteWarehouseApi } from 'api/services/uniformManagement';
import { useUniformMgmt } from '../../context/uniformMgmtContext';
import WarehouseFormModal from './WarehouseFormModal';
import DeleteModal from 'components/modelpopup/DeleteModal';
import { itemRender } from 'utils/table';
import { useNavigate } from 'react-router-dom';

const WarehouseList = () => {
  const { fetchWarehouses } = useUniformMgmt();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const fetchData = () => {
    setLoading(true);
    getWarehousesApi({}).then(response => {
      setData(response.data?.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEdit = (record) => {
    setSelectedWarehouse(record);
    setShowModal(true);
  };

  const handleDelete = () => {
    deleteWarehouseApi(deleteId).then(() => {
      toast.success('Warehouse deactivated', { position: "top-right", autoClose: 3000, transition: Bounce });
      setDeleteModal(false);
      setDeleteId(null);
      fetchData();
      fetchWarehouses();
    }).catch(() => {
      toast.error('Failed to delete warehouse', { position: "top-right", autoClose: 3000, transition: Bounce });
    });
  };

  const handleSuccess = () => {
    setShowModal(false);
    setSelectedWarehouse(null);
    fetchData();
    fetchWarehouses();
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: true,
      render: (text, record) => (
        <a onClick={() => navigate(`/uniform-management/warehouses/${record.id}`)}
          style={{ cursor: 'pointer', color: '#D3001A' }}>
          {text}
        </a>
      )
    },
    { title: 'Code', dataIndex: 'code', sorter: true },
    { title: 'Address', dataIndex: 'address', render: (val) => val || '-' },
    { title: 'Contact Person', dataIndex: 'contact_person', render: (val) => val || '-' },
    { title: 'Contact Number', dataIndex: 'contact_number', render: (val) => val || '-' },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status) => (
        <span className={`badge ${status ? 'bg-success-light' : 'bg-danger-light'}`}>
          {status ? 'Active' : 'Inactive'}
        </span>
      )
    },
    {
      title: 'Action',
      render: (_, record) => (
        <div className="d-flex gap-2">
          <Button icon="fa fa-pencil" className="btn btn-sm btn-outline-primary" onClick={() => handleEdit(record)} />
          <Button icon="fa fa-trash" className="btn btn-sm btn-outline-danger"
            onClick={() => { setDeleteId(record.id); setDeleteModal(true); }} />
        </div>
      )
    }
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Warehouses</h4>
        <Button label="Add Warehouse" icon="fa fa-plus" className="btn btn-primary btn-sm"
          onClick={() => { setSelectedWarehouse(null); setShowModal(true); }} />
      </div>

      <Table
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id}
        loading={loading}
        pagination={{ total: data.length, showSizeChanger: true, itemRender }}
        scroll={{ x: "max-content" }}
      />

      <WarehouseFormModal
        open={showModal}
        onClose={() => { setShowModal(false); setSelectedWarehouse(null); }}
        selectedWarehouse={selectedWarehouse}
        onSuccess={handleSuccess}
      />

      <DeleteModal
        Name="Delete Warehouse"
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        deleteHandler={handleDelete}
      />
    </div>
  );
};

export default WarehouseList;
